import $ from 'jquery';
import './core.js';

$(document).ready(function () {

    const searchCatalogSelectors = {
        searchFilterForm:                  '#search-filter-form',
        searchProductsContainer:           '#search-products-container',
        searchFiltersContainer:            '#search-filters-container',
        searchCarSelectorContainer:        '#search-car-selector-container',
        paginationContainer:               '#pagination-container',
    };

    const $form = $(searchCatalogSelectors.searchFilterForm);

    const config = {
        input:              '[data-header-search-input]',
        popup:              '[data-header-search-popup]',
        dropdown:           '[data-header-search-dropdown]',
        popularCategories:  '[data-header-popular-categories]',
        buttonMore:         '[data-header-search-more]',
        headerSearchForm:   '._js-header-search',
        suggestTimeout:     300
    };

    let searchInterval = null;

    // --- Функция AJAX запроса (AUTOCOMPLETE) ---
    function loadAfterKeyupSearchInput(url, keyword, dropdownBlock)
    {
        $.ajax({
            url: url,
            type: 'POST',
            data: {
                keyword: keyword
            },
            beforeSend: function () {
                // Можно добавить лоадер/спиннер, если нужно
                // dropdownBlock.html('<div class="loading">Загрузка...</div>').show();
            },
            success: function (responseHtml) {
                console.log(responseHtml)
                if (responseHtml.success && responseHtml.view && $.trim(responseHtml.view).length > 0) {
                    dropdownBlock.html(responseHtml.view).show();
                    $(config.buttonMore).show();
                } else {
                    dropdownBlock.hide();
                    $(config.buttonMore).hide();
                }
            },
            error: function (err) {
                console.error('Ошибка поиска:', err);
                dropdownBlock.hide();
            }
        });
    }

    // --- Логика запуска поиска ---
    function performSearch($input)
    {
        const url = $input.data('url'); // URL берем из атрибута data-url у инпута
        const keyword = $input.val().trim();
        const dropdownBlock = $(config.dropdown);

        console.log(dropdownBlock)

        // Синхронизация значений (если есть второй инпут)
        $(config.headerSearchForm).find('input').val(keyword);

        if (keyword.length > 2) {
            loadAfterKeyupSearchInput(url, keyword, dropdownBlock);
        } else {
            // Если стерли текст - скрываем результаты
            dropdownBlock.hide();
            // Можно снова показать популярные категории
            // $(config.popularCategories).show();
        }
    }

    // --- События ШАПКИ ---

    // 1. Focus
    $(document).on('focus', config.input, function () {
        const keyword = $(this).val();
        if (keyword.length <= 2) {
            // $(config.popularCategories).show();
        } else {
            // Если там уже есть текст, можно сразу показать результаты (если они были скрыты)
            $(config.dropdown).show();
        }
    });

    // 2. Keyup (Ввод текста)
    $(document).on('keyup', config.input, function () {
        const $thisInput = $(this);
        clearTimeout(searchInterval);
        searchInterval = setTimeout(function () {
            performSearch($thisInput);
        }, config.suggestTimeout);
    });

    // 3. Клик вне поиска (Закрытие)
    $(document).on('click', function (e) {
        // Если кликнули НЕ по инпуту и НЕ по выпадашке
        if (!$(e.target).closest(config.popup).length) {
            $(config.dropdown).hide();
            $(config.popularCategories).hide();
            $(config.buttonMore).hide();

			$(config.input).val('');
			$(config.headerSearchForm).find('input').val('');
        }
    });

    // 4. Кнопка "Show more results"
    $(document).on('click', config.buttonMore, function () {
        let $headerForm = $(this).closest('.header-search').find('form');
        $headerForm[0].submit();
    });

    /**
     * ============================================================================
     * ЧАСТЬ 2: SEARCH PAGE (ФИЛЬТРЫ)
     * ЭТОТ КОД РАБОТАЕТ ТОЛЬКО ЕСЛИ ЕСТЬ ФОРМА ФИЛЬТРА
     * ============================================================================
     */

    if ($form.length > 0) {
        const $carContainer = $(searchCatalogSelectors.searchCarSelectorContainer);

        function performAjax()
        {
            sendAjax($form.attr('action'), new FormData($form[0]));
        }

        $form.on('submit', function (e) {
            e.preventDefault(); // Важно: отменяем перезагрузку страницы
            performAjax();
        });

        $form.on('change', 'input, select', function () {
            performAjax();
        });

        // Кнопка очистки (делегирование)
        // $(document).on('click', '[data-selector-clear]', function () {
        //     let url = $(this).data('url');
        //
        //     if ($carContainer.length) {
        //         $carContainer.find('select').val('0');
        //         sendAjax($form.attr('action'), new FormData($form[0]));
        //     }
        //
        //     $.ajax({
        //         url: url,
        //         method: 'POST',
        //         success: function () {
        //             location.reload();
        //         },
        //         error: function () {}
        //     });
        // });

        $(document).on('click', '[data-selector-clear]', function () {
            let $btn = $(this);
            let url = $btn.data('url');
            let pageType = $carContainer.data('page-type');

            $.ajax({
                url: url,
                method: 'POST',
                success: function () {
                    if (pageType === 'search') {
                        if ($carContainer.length) {
                            // Сбрасываем визуально
                            $carContainer.find('select').val('0').trigger('change');
                            sendAjax($form.attr('action'), new FormData($form[0]));
                        }
                    }
                },
                error: function () {
                    console.error('Ошибка при очистке сессии');
                }
            });
        });

        // Пагинация
        $(document).on('click', '.pagination__item-link, .pagination__arrow-link', function (e) {
            e.preventDefault();

            const $link = $(this);
            const $li = $link.closest('li');

            if ($li.hasClass('disabled') || $li.hasClass('active')) return;

            const url = $link.attr('href');
            if (!url || url === '#') return;

            const formData = new FormData($form[0]);
            try {
                const urlObj = new URL(url);
                urlObj.searchParams.forEach((val, key) => formData.set(key, val));
                sendAjax(url, formData);
            } catch (err) {
                console.error(err);
            }
        });

        function sendAjax(url, formData)
        {
            const params = new URLSearchParams();

            for (const [key, value] of formData.entries()) {
                if (key !== '_token' && value !== '0' && value !== '') {
                    params.append(key, value);
                }
            }

            const newUrl = window.location.pathname + '?' + params.toString();
            window.history.pushState({}, '', newUrl);

            $.ajax({
                url: url,
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (htmlResponse) {
                    const $response = $('<div>').html(htmlResponse);

                    updateBlock($response, searchCatalogSelectors.searchCarSelectorContainer);
                    updateBlock($response, searchCatalogSelectors.searchProductsContainer);
                    updateBlock($response, searchCatalogSelectors.searchFiltersContainer);
                    updateBlock($response, searchCatalogSelectors.paginationContainer);

                    console.log('✅ Контент обновлен');
                },
                error: function (xhr) {
                    console.error('AJAX Error:', xhr.statusText);
                }
            });
        }

        function updateBlock($responseObject, selector)
        {
            const $currentBlock = $(selector);
            const $newBlock = $responseObject.find(selector);
            if ($currentBlock.length && $newBlock.length) {
                $currentBlock.html($newBlock.html());
            }
        }

    }
});
